import { Chip } from "@mui/material";
import { ProposalStatus } from "../../../../types/proposal.types";

const statusStyles: Record<ProposalStatus, { bgcolor: string; color: string }> = {
  Sent: { bgcolor: "#16a34a", color: "white" },
  Declined: { bgcolor: "#ef4444", color: "white" },
  Draft: { bgcolor: "#e2e8f0", color: "#64748b" },
  Accepted: { bgcolor: "#3b82f6", color: "white" },
  Final: { bgcolor: "#7c3aed", color: "white" },
};

interface StatusChipProps {
  status: ProposalStatus;
}

export default function StatusChip({ status }: StatusChipProps) {
  const style =
    statusStyles[status] ??
    statusStyles[
      (status.charAt(0).toUpperCase() +
        status.slice(1).toLowerCase()) as ProposalStatus
    ];
  return (
    <Chip
      label={status}
      sx={{
        bgcolor: style.bgcolor,
        color: style.color,
        fontWeight: 700,
        fontSize: "11px",
        height: 24,
        borderRadius: "20px",
        "& .MuiChip-label": { px: 1.5 },
      }}
    />
  );
}